// extracted by mini-css-extract-plugin
export default {"itemLabel":"style_itemLabel__Y5qkJ","actionButtonsContainer":"style_actionButtonsContainer__8DMKe","infoContainer":"style_infoContainer__DFipD"};